import React, { useMemo } from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { stripHtmlTags } from '@berlitz/max-utils/lib/stripHtmlTags'
import resizeImage from '@berlitz/max-utils/lib/resizeImage'

const getRobotsMetaContent = (noIndex, noFollow) => {
  const robotsMetaAttributes = []
  if (noIndex) robotsMetaAttributes.push('noindex')
  if (noFollow) robotsMetaAttributes.push('nofollow')
  return robotsMetaAttributes.join(',')
}

const HeadContainer = ({
  description,
  noFollow,
  imageUrl,
  noIndex,
  pageLocale,
  pathName,
  title,
  canonical,
}) => {
  // Get site URL from gatsby-config.js
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const siteUrl = site.siteMetadata.siteUrl
  const fullPageUrl = `${siteUrl}${pathName || ''}`
  const canonicalUrl = canonical || fullPageUrl

  const resizedImageUrl = imageUrl ? resizeImage(imageUrl, 1200, 630) : ''
  const titleClean = useMemo(() => stripHtmlTags(title), [title])
  const robotsMetaContent = useMemo(
    () => getRobotsMetaContent(noIndex, noFollow),
    [noIndex, noFollow]
  )
  const lang = pageLocale?.split('-')?.[0] || null

  return (
    <>
      <Helmet htmlAttributes={{ lang }}>
        <title>{titleClean}</title>
        <meta name="title" content={titleClean} />
        <meta name="description" content={description} />
        <meta property="og:title" content={titleClean} />
        <meta property="og:site_name" content="Berlitz" />
        <meta property="og:image" content={resizedImageUrl} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={titleClean} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={resizedImageUrl} />
        {robotsMetaContent && (
          <meta name="robots" content={robotsMetaContent} />
        )}
        {noIndex && <meta name="googlebot" content="noindex" />}
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
    </>
  )
}

export default HeadContainer
